import { Component } from 'react'
import styled from 'styled-components'
import { media } from '../../../styles/media'

import Container from '../../layout/Container'
import LazyImage from '../../display/LazyImage'
import Vimeo from '../../Vimeo'
import CrossOutIcon from '../../icons/CrossOut'

import { Section, SectionHeader, SectionSubtitle } from '../../display/Landing'

import PlayButtonIcon from './PlayButton'

const Wrapper = styled.section`
  ${Section} {
    width: 100%;
    max-width: 1268px;
    margin: 0 auto;
    position: relative;
    z-index: 3;
  }

  ${Container} {
    max-width: 968px;

    ${SectionSubtitle} {
      @media (min-width: 768px) {
        font-size: 24px;
      }
    }
  }

  @media (min-width: 1268px) {
    ${Section} {
      margin-top: -100px;
    }
  }
`

const PlayButton = styled(PlayButtonIcon)`
  opacity: 0.8;
  transition: opacity 300ms ease-out;

  &:hover {
    opacity: 1;
  }
`

const Media = styled.div`
  position: relative;

  border-radius: 8px;
  overflow: hidden;
  /*
    border-radius & overflow not sufficient on WebKit (i.e. Safari)
    https://bugs.webkit.org/show_bug.cgi?id=140535
  */
  z-index: 0;

  width: 100%;
  height: calc((110 / 267) * 100vw);
  ${({ height }) =>
    height &&
    `
    height: ${height};
  `}

  min-height: 400px;
  max-height: 800px;

  ${media.md`
    min-height: 500px;
  `}

  background-color: ${({ theme }) => theme.brand.forest};
  background-color: #000;

  ${LazyImage} {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
`
export const FullScreenVideo = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999;

  background-color: #000;
  opacity: 1;
  transition: opacity 300ms ease-out;

  opacity: 0;
  pointer-events: none;

  ${({ playing }) =>
    playing &&
    `
    opacity: 1;
    pointer-events: auto;
  `}
`

export const FullScreenVideoHeader = styled.div`
  position: absolute;
  padding: 20px 0;
  top: 0;
  right: 16px;

  color: white;
  text-align: right;

  svg {
    width: 40px;
    height: 40px;
  }

  @media (min-width: 768px) {
    padding: 40px 0;
  }
`
export const CloseButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
`

const posterImageSrc =
  'https://assets.riparide.com/video_about_riparide/poster_2022-04-19.jpg'

// const posterImageSrcset = `
//   https://assets.riparide.com/video_about_riparide/poster_1x_25-03-2022.jpg 864w,
//   https://assets.riparide.com/video_about_riparide/poster_2x_25-03-2022.jpg 1728w,
//   https://assets.riparide.com/video_about_riparide/poster_3x_25-03-2022.jpg 2592w
// `

class LargeVideo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      playing: false,
    }
  }

  handlePlayVideo = () => {
    this.setState(
      {
        open: true,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              playing: true,
            },
            () => {
              this.video.play()
            },
          )
        }, 200)
      },
    )
  }

  handleClose = () => {
    this.setState(
      {
        playing: false,
      },
      () => {
        this.video.pause()
        setTimeout(() => {
          this.setState({
            open: false,
          })
        }, 200)
      },
    )
  }

  render() {
    const { open, playing } = this.state
    const { children, url, height } = this.props

    return (
      <div>
        <Media height={height}>
          <PlayButton onClick={this.handlePlayVideo} />
          <LazyImage
            data-src={posterImageSrc}
            alt="Video about Riparide"
            // data-srcset={posterImageSrcset}
          />
        </Media>
        {open && (
          <FullScreenVideo playing={playing}>
            <FullScreenVideoHeader>
              <CloseButton onClick={this.handleClose}>
                <CrossOutIcon />
              </CloseButton>
            </FullScreenVideoHeader>
            <Vimeo
              ref={(video) => {
                this.video = video
              }} // eslint-disable-line no-return-assign
              url={url || 'https://player.vimeo.com/video/698890830'}
            />
          </FullScreenVideo>
        )}
        {children}
      </div>
    )
  }
}

const InlineBanner = (props) => {
  return (
    <Wrapper>
      <LargeVideo {...props}>
        <Section centered sand>
          <Container>
            <SectionHeader>Live Fully</SectionHeader>
            <SectionSubtitle>
              Time spent in nature fulfills the human soul. Riparide is here to
              inspire people to unplug from modern-day trappings and head
              outdoors in search of fulfilling moments.
            </SectionSubtitle>
            <SectionSubtitle as="div" noMargin>
              Visit <a href="/about">About Us</a> for more
            </SectionSubtitle>
          </Container>
        </Section>
      </LargeVideo>
    </Wrapper>
  )
}

export { LargeVideo }

export default InlineBanner
